import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import queryString from 'query-string';

import { RootState } from 'ev-store';

import { BACKEND_PROXY } from 'ev-config/config';

const baseQuery = (baseUrl = '/') => {
  return fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('Secure-Authentication-Token', token);
      }
      if (BACKEND_PROXY) {
        headers.set('x-target-host', BACKEND_PROXY);
      }
      return headers;
    },
    paramsSerializer: params => {
      return queryString.stringify(params, { arrayFormat: 'bracket' });
    },
  });
};

export enum Tags {
  User = 'User',
  Schedule = 'Schedule',
  PersonalFilterViews = 'PersonalFilterViews',
  Visits = 'Visits',
  FavoriteMedications = 'FavoriteMedications',
  VisitPrescriptions = 'VisitPrescriptions',
  SupportedInsuranceDynamicFields = 'SupportedInsuranceDynamicFields',
  ManualInsuranceDynamicFields = 'ManualInsuranceDynamicFields',
  SearchPatients = 'search-patients',
  Providers = 'Providers',
  VisitTypeMemberships = 'VisitTypeMemberships',
  ServesLocation = 'ServesLocation',
  VisitTypes = 'VisitTypes',
  EvaultDocument = 'EvaultDocument',
  CustomColumns = 'CustomColumns',
  Segments = 'Segments',
  CustomNotes = 'CustomNotes',
  VisitStatuses = 'VisitStatuses',
  VisitParticipants = 'VisitParticipants',
  CustomActions = 'CustomActions',
  PracticeDevices = 'PracticeDevices',
  Customer = 'Customer',
  AdminPractices = 'AdminPractices',
  AdminLanguageQuickSelects = 'AdminLanguageQuickSelects',
  AdminVideoBackgrounds = 'AdminVideoBackgrounds',
  CustomForms = 'CustomForms',
  CustomerRoles = 'CustomerRoles',
  CustomerUsers = 'CustomerUsers',
  CustomForm = 'CustomForm',
  CustomFormSubmissions = 'CustomFormSubmissions',
  CustomFormSubmissionsEditing = 'CustomFormSubmissionsEditing',
  EData = 'EData',
  Qtc = 'QTC',
  VisitAttendeeMembership = 'VisitAttendeeMembership',
  AdminCustomerPhoneNumbers = 'AdminCustomerPhoneNumbers',
  AdminOutboundPhoneNumbers = 'AdminOutboundPhoneNumbers',
  FrontDoors = 'FrontDoors',
  Journeys = 'Journeys',
  JourneyTriggers = 'JourneyTriggers',
  CustomDocuments = 'CustomDocuments',
  CustomDocument = 'CustomDocument',
  CurrentPractice = 'CurrentPractice',
  Availability = 'Availability',
  StatsDashboard = 'StatsDashboard',
}

export const AllAvailableTags = Object.values(Tags);

export enum Base {
  V2 = 'api/v2',
  V3 = 'api/v3',
  V4 = 'api/v4',
  Sch = 'api/sch',
  None = '',
}

const api = createApi({
  baseQuery: baseQuery(BACKEND_PROXY ? '/r-static/proxy/' : '/'),
  tagTypes: AllAvailableTags,
  endpoints: () => ({}),
});

export default api;
